export const MAX_WIDTH = 30;
export const MIN_WIDTH = 5;
export const LINE_HEIGHT = 42;